import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';

import { CmpsCoachingTagsModule } from '../../../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { epicObs } from '../../../../store';
import { CmpsCommentModule } from '../comment';

import { BehaviourSelectionDialogComponent } from './behaviour-selection-dialog.component';
import { behaviourSelectionDialogEpics } from './behaviour-selection-dialog.epic';
import { TranslationIdMap } from './behaviour-selection-dialog.i18n';

@NgModule({
    declarations: [BehaviourSelectionDialogComponent],
    exports: [BehaviourSelectionDialogComponent],
    imports: [
        CmpsButtonModule,
        CmpsCheckboxModule,
        CmpsCoachingTagsModule,
        CmpsCommonModule,
        CmpsCommentModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CmpsCoachingBehaviourSelectionDialogModule {
    constructor() {
        behaviourSelectionDialogEpics.forEach((e) => epicObs.next(e));
    }
}
